import { jsx } from 'react/jsx-runtime';
import { dispatchFabricEvent } from '../hooks/useFabricEvent.js';
import { ToolbarItemType } from './toolbar.types.js';
import { IconSidePanelAssistant, IconSidePanelSimilar } from '@fabric-app/icons/svg';
import { useAssistantStore } from '../assistant/stores/assistantStore.js';
import { MAX_PERSISTENT_TEXT_SNIPPETS_CONTEXT_SIZE } from '../assistant/constants.js';

const aiGroup = (getSelectedText) => ({
  name: "ai",
  label: "AI",
  isHidden: () => {
    const selectedText = getSelectedText();
    return !selectedText.length || selectedText.length >= 1e3;
  },
  items: [
    {
      type: ToolbarItemType.Dropdown,
      key: "askAi",
      label: "Ask AI",
      icon: /* @__PURE__ */ jsx(IconSidePanelAssistant, {}),
      items: [
        {
          name: "askAiGroup",
          label: "Ask AI...",
          items: [
            {
              type: ToolbarItemType.Button,
              key: "addToContext",
              label: "Add to assistant context",
              onClick: () => {
                const selectedText = getSelectedText();
                if (!selectedText.length) return;
                dispatchFabricEvent("fabric-assistant-action", {
                  type: "add-to-context",
                  text: selectedText
                });
              },
              isDisabled: () => {
                const textCount = useAssistantStore.getState().persistentContext.textSnippets.length;
                if (textCount >= MAX_PERSISTENT_TEXT_SNIPPETS_CONTEXT_SIZE) {
                  return `You can only add up to ${MAX_PERSISTENT_TEXT_SNIPPETS_CONTEXT_SIZE} text snippets to the assistant context`;
                }
                return false;
              }
            },
            {
              type: ToolbarItemType.Button,
              key: "askSelection",
              label: "Ask about selection",
              onClick: () => {
                const selectedText = getSelectedText();
                if (!selectedText.length) return;
                dispatchFabricEvent("fabric-assistant-action", {
                  type: "add-to-context",
                  text: selectedText,
                  resetContext: true
                });
              }
            },
            {
              type: ToolbarItemType.Button,
              key: "summarizeSelection",
              label: "Summarize selection",
              onClick: () => {
                const selectedText = getSelectedText();
                if (!selectedText.length) return;
                dispatchFabricEvent("fabric-assistant-action", {
                  type: "summarize",
                  text: selectedText
                });
              }
            }
          ]
        }
      ]
    },
    {
      type: ToolbarItemType.Button,
      key: "similar",
      label: "See similar items",
      icon: /* @__PURE__ */ jsx(IconSidePanelSimilar, {}),
      onClick: () => {
        const selectedText = getSelectedText();
        if (!selectedText.length) return;
        dispatchFabricEvent("fabric-search-action", {
          type: "search",
          query: selectedText
        });
      },
      variant: "secondary"
    }
  ]
});

export { aiGroup };
//# sourceMappingURL=toolbar.config.js.map
